const useStyles = () => {
    return {
        comment: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .color-primary': {
                color: 'primary.100'
            },
            '& .color-delete': {
                color: 'c_red.main'
            },
        },
        addorment: {
            alignItems: 'start',
            position: 'relative',
            bottom: '-10px',
            right: '-10px'
        },
    }
}

export { useStyles }